export const FEATURE_NAMESPACE = 'feature.shift-events-affiliates'
